import React from "react";
import {Tooltip} from "./index";

const bigintFormatCompact = { notation: 'compact', maximumFractionDigits: 1 };
const bigintFormatScientific = { notation: 'scientific', maximumFractionDigits: 1 };

export default class SkillOption extends React.Component {
	onClick = (skill) => {
		if (this.props.data.influence >= (skill.price * 1000n)) {
			const effect = {}
			Object.keys(this.props.store.print).forEach((key) => {
				console.log(this.props.data[key])
				effect[key] = this.props.data[key] + this.props.store.print[key] * 10n * this.props.data[`storeCount${this.props.num}`] * (skill.bonus - ((this.props.data[`skillLevel${this.props.num}`]) ? this.props.skill[this.props.data[`skillLevel${this.props.num}`] - 1n].bonus : 1n))
			})

			console.log(effect, skill.bonus)
			this.props.updateData({
				influence: this.props.data.influence - (skill.price * 1000n),
				[`skillLevel${this.props.num}`]: this.props.data[`skillLevel${this.props.num}`] + 1n,
					...effect
			})
		}
	}

	render() {
		if (!this.props.data[`storeCount${this.props.num}`] || this.props.data[`skillLevel${this.props.num}`] >= this.props.skill.length)
			return (<div/>)

		const skill = this.props.skill[this.props.data[`skillLevel${this.props.num}`]]
		return (
			<Tooltip text={skill.description} title={skill.name} price={skill.price.toLocaleString('en-US', (skill.price / 1000000000000000n > 0n) ? bigintFormatScientific : bigintFormatCompact )}>
				<div className={"shop-button"} onClick={() => { this.onClick(skill) }} style={{ cursor: 'pointer', marginLeft: 10, marginBottom: 5, padding: 5, display: 'flex', flexDirection: 'row', borderStyle: 'solid', borderWidth: 1, borderColor: '#6d6d6d' }}>
					{skill.picture}
				</div>
			</Tooltip>
		)
	}
}